var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { forwardRef } from 'react';
typeof window !== 'undefined' && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = '2.10.0');
import { textDefaultProps } from './props';
import * as S from './styles';
const DisplayLarge = forwardRef((_a, ref) => {
  var {
      tag,
      color,
      display
    } = _a,
    rest = __rest(_a, ["tag", "color", "display"]);
  return React.createElement(S.InnerText, Object.assign({
    variant: "display-large",
    as: tag,
    "data-ds-component": "DS-Text"
  }, rest, {
    "$color": color,
    "$display": display,
    ref: ref
  }));
});
DisplayLarge.defaultProps = textDefaultProps;
DisplayLarge.displayName = 'Text.DisplayLarge';
const DisplayMedium = forwardRef((_a, ref) => {
  var {
      tag,
      color,
      display
    } = _a,
    rest = __rest(_a, ["tag", "color", "display"]);
  return React.createElement(S.InnerText, Object.assign({
    "data-ds-component": "DS-Text",
    variant: "display-medium",
    as: tag
  }, rest, {
    "$color": color,
    "$display": display,
    ref: ref
  }));
});
DisplayMedium.defaultProps = textDefaultProps;
DisplayMedium.displayName = 'Text.DisplayMedium';
const TitleLarge = forwardRef((_a, ref) => {
  var {
      tag,
      color,
      display
    } = _a,
    rest = __rest(_a, ["tag", "color", "display"]);
  return React.createElement(S.InnerText, Object.assign({
    "data-ds-component": "DS-Text",
    variant: "title-large",
    as: tag
  }, rest, {
    "$color": color,
    "$display": display,
    ref: ref
  }));
});
TitleLarge.defaultProps = textDefaultProps;
TitleLarge.displayName = 'Text.TitleLarge';
const TitleMedium = forwardRef((_a, ref) => {
  var {
      tag,
      color,
      display
    } = _a,
    rest = __rest(_a, ["tag", "color", "display"]);
  return React.createElement(S.InnerText, Object.assign({
    "data-ds-component": "DS-Text",
    variant: "title-medium",
    as: tag
  }, rest, {
    "$color": color,
    "$display": display,
    ref: ref
  }));
});
TitleMedium.defaultProps = textDefaultProps;
TitleMedium.displayName = 'Text.TitleMedium';
const TitleSmall = forwardRef((_a, ref) => {
  var {
      tag,
      color,
      display
    } = _a,
    rest = __rest(_a, ["tag", "color", "display"]);
  return React.createElement(S.InnerText, Object.assign({
    "data-ds-component": "DS-Text",
    variant: "title-small",
    as: tag
  }, rest, {
    "$color": color,
    "$display": display,
    ref: ref
  }));
});
TitleSmall.defaultProps = textDefaultProps;
TitleSmall.displayName = 'Text.TitleSmall';
const SubtitleLarge = forwardRef((_a, ref) => {
  var {
      tag,
      color,
      display
    } = _a,
    rest = __rest(_a, ["tag", "color", "display"]);
  return React.createElement(S.InnerText, Object.assign({
    "data-ds-component": "DS-Text",
    variant: "subtitle-large",
    as: tag
  }, rest, {
    "$color": color,
    "$display": display,
    ref: ref
  }));
});
SubtitleLarge.defaultProps = textDefaultProps;
SubtitleLarge.displayName = 'Text.SubtitleLarge';
const SubtitleMedium = forwardRef((_a, ref) => {
  var {
      tag,
      color,
      display
    } = _a,
    rest = __rest(_a, ["tag", "color", "display"]);
  return React.createElement(S.InnerText, Object.assign({
    "data-ds-component": "DS-Text",
    variant: "subtitle-medium",
    as: tag
  }, rest, {
    "$color": color,
    "$display": display,
    ref: ref
  }));
});
SubtitleMedium.defaultProps = textDefaultProps;
SubtitleMedium.displayName = 'Text.SubtitleMedium';
const BodyLarge = forwardRef((_a, ref) => {
  var {
      tag,
      color,
      display
    } = _a,
    rest = __rest(_a, ["tag", "color", "display"]);
  return React.createElement(S.InnerText, Object.assign({
    "data-ds-component": "DS-Text",
    variant: "body-large",
    as: tag
  }, rest, {
    "$color": color,
    "$display": display,
    ref: ref
  }));
});
BodyLarge.defaultProps = textDefaultProps;
BodyLarge.displayName = 'Text.BodyLarge';
const BodyMedium = _a => {
  var {
      tag,
      color,
      display
    } = _a,
    rest = __rest(_a, ["tag", "color", "display"]);
  return React.createElement(S.InnerText, Object.assign({
    "data-ds-component": "DS-Text",
    variant: "body-medium",
    as: tag
  }, rest, {
    "$color": color,
    "$display": display
  }));
};
BodyMedium.defaultProps = textDefaultProps;
BodyMedium.displayName = 'Text.BodyMedium';
const BodySmall = forwardRef((_a, ref) => {
  var {
      tag,
      color,
      display
    } = _a,
    rest = __rest(_a, ["tag", "color", "display"]);
  return React.createElement(S.InnerText, Object.assign({
    "data-ds-component": "DS-Text",
    variant: "body-small",
    as: tag
  }, rest, {
    "$color": color,
    "$display": display,
    ref: ref
  }));
});
BodySmall.defaultProps = textDefaultProps;
BodySmall.displayName = 'Text.BodySmall';
const Caption = forwardRef((_a, ref) => {
  var {
      tag,
      color,
      display
    } = _a,
    rest = __rest(_a, ["tag", "color", "display"]);
  return React.createElement(S.InnerText, Object.assign({
    "data-ds-component": "DS-Text",
    variant: "caption",
    as: tag
  }, rest, {
    "$color": color,
    "$display": display,
    ref: ref
  }));
});
Caption.defaultProps = textDefaultProps;
Caption.displayName = 'Text.Caption';
const Overline = forwardRef((_a, ref) => {
  var {
      tag,
      color,
      display
    } = _a,
    rest = __rest(_a, ["tag", "color", "display"]);
  return React.createElement(S.InnerText, Object.assign({
    "data-ds-component": "DS-Text",
    variant: "overline",
    as: tag
  }, rest, {
    "$color": color,
    "$display": display,
    ref: ref
  }));
});
Overline.defaultProps = textDefaultProps;
Overline.displayName = 'Text.Overline';
export const Text = {
  /**
   * Estilo de título com sua utilização destinada principalmente em landing pages. Use no máximo um por interface, na parte superior da tela.
   */
  DisplayLarge: DisplayLarge,
  /**
   * Também destinado para aplicações em landing pages, mas devido ao seu tamanho um pouco menor, é indicado para cenários onde o título da página possui mais caracteres.
   * Como excessão, pode ser aplicado mais de uma vez apenas para separar blocos de conteúdo caso a interface já possua seu título principal usando o estilo Display XL.
   */
  DisplayMedium: DisplayMedium,
  /**
   * Deve ser aplicado apenas no topo, acima das pages. Ele deve aparecer apenas uma vez por tela dentro do produto.
   */
  TitleLarge: TitleLarge,
  /**
   * Pode aparecer mais de uma vez por página, já que pode ser usado para separar o conteúdo blocos de informação, mas não utilizá-lo como o título principal da página no desktop.
   */
  TitleMedium: TitleMedium,
  /**
   * O Título Small pode ser usado para subdivir o conteúdo em mais blocos de informação ou aplicado em componentes (como a galeria de anúncios).
   */
  TitleSmall: TitleSmall,
  /**
   * Utilize o subtitle Large apenas combinado com os títulos Display. Nunca o utilize como o título principal da página.
   */
  SubtitleLarge: SubtitleLarge,
  /**
   * Aplique o subtitle Medium sempre próximo ao Title Large. Não aplique-o próximo aos Displays (para isso utilize o subtitle large), ou Title Medium e Small.
   */
  SubtitleMedium: SubtitleMedium,
  /**
   * Este estilo é mais indicado para utilizar em textos longos (como páginas de FAQ), ou em landing pages que estejam utilizando os estilos maiores, como o Display Large e Subtitle Large.
   * Além do regular, nos estilos de texto de parágrafo é possível usar as variações de bold, semibold e itálico, quando necessário
   * Não aplique-os como títulos ou subtítulos.
   */
  BodyLarge: BodyLarge,
  /**
   * Indicado para textos corridos, como descrição de anúncios, corpos de textos de FAQs.
   * Além do regular, nos estilos de texto de parágrafo é possível usar as variações de bold, semibold e itálico, quando necessário
   */
  BodyMedium: BodyMedium,
  /**
   * Indicado para textos menores ou de apoio. Pode ser aplicado como links, em bullet lists, componentes como o drop menu.
   * Além do regular, nos estilos de texto de parágrafo é possível usar as variações de bold, semibold e itálico, quando necessário
   */
  BodySmall: BodySmall,
  /**
   * Captions são usados para explicações rápidas, sucintas e pontuais, podendo acompanhar algum ícone, ilustração, form item ou similar. Seu tamanho é menor do que um recomendado para leitura, por isso utilize-o para frases curtas e diretas.
   */
  Caption: Caption,
  /**
   * O Overline é o nosso componente com o menor font size. Ele pode ser utilizado para  introduzir algum título ou lista.
   * Por estar sempre em upercase para compensar seu tamanho reduzido, utilize-o apenas em frases com poucas palavras.
   */
  Overline: Overline
};